import { addErrorHandler, getAppStatus, registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
import { BehaviorSubject, Subject } from 'rxjs'
import { HTMLLayoutData } from "single-spa-layout/dist/types/isomorphic/constructRoutes";

// "@agt/agendamento": "https://portal-service.minfin.gov.ao/agendamento/main.js", 

const notificationSubject = new BehaviorSubject<boolean>(false);
const loginMode = new BehaviorSubject<string>('CLIENT');
const routeEventSubject = new BehaviorSubject<string>('');
const tokenSubject = new BehaviorSubject<any>(undefined);
const keycloakSubject = new Subject<any>();
const authUserSubscription = new BehaviorSubject<any>(null);
const authChangeSubject = new BehaviorSubject<any>(undefined);
const representanteSubject = new BehaviorSubject<any>(undefined);
const btnLogin = new BehaviorSubject<boolean>(true)
var myImage = require("./loading.gif");

const data: HTMLLayoutData = {
  loaders: {
    mainLoader: `
    <div style="width: 100%; margin-top: 25vh; display: flex; justify-content: center;">
        <img src="${myImage}" style="height: 100px; width: 200px"></img>
    </div>
    `,
  },
  props: {
    loginMode,
    routeEventSubject,
    tokenSubject,
    keycloakSubject,
    authChangeSubject,
    representanteSubject,
    notificationSubject,
    authUserSubscription,
    btnLogin
  },
  errors: {
    mainError: `
    <div style="width: 100%; margin-top: 25vh; display: flex; justify-content: center;">
        <img src="${myImage}"></img>
    </div>
    `,
  }
}

addErrorHandler(err => {
  /* console.log(err); */
  console.log(err.appOrParcelName);
  console.log(getAppStatus(err.appOrParcelName));
  var href = window.location.href;
  if (href == 'https://irt.minfin.gov.ao/') {
    window.location.href = 'https://irt.minfin.gov.ao/irt'
  }
  if (href == 'https://ip.minfin.gov.ao/') {
    window.location.href = 'https://ip.minfin.gov.ao/ip'
  }
  if (href == 'https://pagamentoprestacao.minfin.gov.ao/') {
    window.location.href = 'https://pagamentoprestacao.minfin.gov.ao/consulta-nota-liquidacao'
  }
});

const routes = constructRoutes(microfrontendLayout, data);

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();
start();

loginMode.next('CLIENT');

//Chamando funções costumizadas
setNavigationEvents();
setToken();
setRepresentante();
//Fim chamada funções


/////////////////////////////////////////////////////////////////////////////
////////////////////////Funções costumizadas/////////////////////////////////
/////////////////////////////////////////////////////////////////////////////

function setNavigationEvents() {
  window.addEventListener('single-spa:routing-event', (evt: any) => {
    routeEventSubject.next(location.pathname + location.search);
  });
}

//setar o token existente no localstorage na primeira execução
function setToken() {
  if (window.localStorage.getItem('token')) {
    tokenSubject.next(window.localStorage.getItem('token'));
  }
  authChangeSubject.subscribe(result => {
    tokenSubject.next(window.localStorage.getItem('token'));
  });

  if (window.localStorage.getItem('token') && window.localStorage.getItem('refresh')) {
    authUserSubscription.next({
      token: window.localStorage.getItem('token'),
      refreshToken: window.localStorage.getItem('refresh')
    });
  }

  authChangeSubject.subscribe(result => {
    authUserSubscription.next({
      token: window.localStorage.getItem('token'),
      refreshToken: window.localStorage.getItem('refresh')
    });
  });


}

//setar o representante existente no localstorage na primeira execução
function setRepresentante() {
  if (window.localStorage.getItem('representante')) {
    representanteSubject.next(window.localStorage.getItem('representante'));
  }
}
//Fim Funções costumizadas.
